import React, { useState, useEffect } from 'react'
import { Space } from "antd"
import Search from "./search"
import Filter from "./filter"

const RestaurantSearch = ({searchIndex, cities, neighborhoods, locations, sendResults}) => {

  //const [results, setResults] = useState(locations)
  const [searchResults, setSearchResults] = useState(locations)
  const [filters, setFilters] = useState([
    {
      name: "All Cities",
      selected: null,
      id: "CityName",
      child: "NeighborhoodName",
      options: [{name: 'All Cities', value:null, id:"default"}].concat(cities.map(city => {return({name: city.Name, value: city.Name, id: city.AirtableID})}))
    },
    {
      name: "All Neighborhoods",
      selected: null,
      id: "NeighborhoodName",
      options: [{name: 'All Neighborhoods', value:null, id:"default"}].concat(neighborhoods.map(hood => {return({
        id: hood.AirtableID,
        name: hood.Name,
        value: hood.Name,
        parent: {
          id: "CityName",
          value: hood.CityName[0],
        }
      })}).sort((a,b) => a.value > b.value ? 1 : -1))
    }
  ])
  //const [runFilter, toggleFilter] = useState(false) // workaround to useEffect not doing deep comparisons on objects

  // when runFilter changes (and therefore filter has changed)
  // filter results against new filters and return outcome to parent 
  useEffect(() => {
    if(searchResults !== null) {
      const filteredResults = searchResults.filter((result) => checkFilters(result))
      //setResults(filteredResults)
      sendResults(filteredResults.map(r => r.RestaurantName && r.RestaurantName[0]))
    } else {
      sendResults(locations.filter((result) => checkFilters(result)).map(r => r.RestaurantName && r.RestaurantName[0]))
    }
    
  }, [filters, searchResults])

  const checkFilters = (location) => {
    for(const i in filters) {
      // if there's a selected value for the filter and location in question has a value under that filter
      // and that value does NOT match the selected filter value, return false
      // (e.g. return false if City filter = Tampa and location has a City but it isn't Tampa)
      // we use includes because the location fields are arrays in this case
      const filterID= filters[i].id
      if ((filters[i].selected && filters[i].selected.value) && location[filterID] && !location[filterID].includes(filters[i].selected.value)) {
        return false
      }
    }
    return true
  }

  return(
    <Space direction="vertical" style={{width:'100%'}}>
      <Search
        placeholder="search for your favorites"
        searchIndex={searchIndex}
        buildResult={(doc) => doc}
        updateResults={(results) => setSearchResults(results)}
      />
      <Filter
        returnFilters={(filterSelections) => {setFilters(filterSelections)}}
        categories={filters}
      />
    </Space>
  )
}

export default RestaurantSearch